import axios from "axios";
import { setAlert } from "./alert";

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get active water quality
export const getActiveWaterQuality = () => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/water-quality`);
    
    dispatch({
      type: "GET_ACTIVE_WATER_QUALITY",
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Get all water quality records
export const getAllWaterQuality = () => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/water-quality/all`);
    
    dispatch({
      type: "GET_ALL_WATER_QUALITY",
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Get water quality by ID
export const getWaterQualityById = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/water-quality/${id}`);
    
    dispatch({
      type: "GET_WATER_QUALITY_BY_ID",
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Create water quality record
export const createWaterQuality = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${API_URL}/water-quality`, formData);
    
    dispatch({
      type: "CREATE_WATER_QUALITY",
      payload: res.data,
    });
    
    dispatch(setAlert("Water quality record created successfully", "success"));
  } catch (err) {
    const errors = err.response?.data?.errors;
    
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Update water quality record
export const updateWaterQuality = (id, formData) => async (dispatch) => {
  try {
    const res = await axios.put(`${API_URL}/water-quality/${id}`, formData);
    
    dispatch({
      type: "UPDATE_WATER_QUALITY",
      payload: res.data,
    });
    
    dispatch(setAlert("Water quality record updated successfully", "success"));
  } catch (err) {
    const errors = err.response?.data?.errors;
    
    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, "danger")));
    }
    
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Delete water quality record
export const deleteWaterQuality = (id) => async (dispatch) => {
  try {
    await axios.delete(`${API_URL}/water-quality/${id}`);
    
    dispatch({
      type: "DELETE_WATER_QUALITY",
      payload: id,
    });
    
    dispatch(setAlert("Water quality record deleted successfully", "success"));
  } catch (err) {
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Upload water quality document
export const uploadWaterQualityDocument = (id, file) => async (dispatch) => {
  try {
    // Validate file type
    if (file.type !== 'application/pdf') {
      dispatch(setAlert("Please upload a PDF file", "danger"));
      return;
    }
    
    // Validate file size (10MB)
    if (file.size > 10 * 1024 * 1024) {
      dispatch(setAlert("File size should be less than 10MB", "danger"));
      return;
    }
    
    const formData = new FormData();
    formData.append('document', file);
    
    const res = await axios.put(`${API_URL}/water-quality/${id}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    dispatch({
      type: "UPLOAD_WATER_QUALITY_DOCUMENT",
      payload: res.data,
    });
    
    dispatch(setAlert("Document uploaded successfully", "success"));
  } catch (err) {
    dispatch({
      type: "WATER_QUALITY_ERROR",
      payload: { msg: err.response?.statusText, status: err.response?.status },
    });
  }
};

// Clear water quality
export const clearWaterQuality = () => (dispatch) => {
  dispatch({ type: "CLEAR_WATER_QUALITY" });
};
